import React from 'react'
import { Link } from 'react-router-dom';

const Humberg = ({ header, headerLink, children, innerChildren }) => {
    return (
        <div className='p-[1vmax_1.5vmax]' >
            <div className="bg-white shadow-1 rounded-xl p-[1vmax_2vmax] flex justify-between items-center">
                <h1 className="text-[1.5vmax] font-bold">{innerChildren || children}</h1>
                <div className="flex items-center gap-[1.5vmax]">
                    <div className="flex gap-[0.5vmax] items-center text-[1vmax]">
                        <Link to={headerLink} className="text-[var(--primary)] hover:underline">
                            {header}
                        </Link>
                        <span className="text-slate-400">/</span>
                        <span className="text-slate-600 font-semibold">{children}</span>
                        {innerChildren &&
                            <>
                                <span className="text-slate-400">/</span>
                                <span className="text-slate-600 font-semibold">{innerChildren}</span>
                            </>
                        }
                    </div>

                    {/* Chat Icon Button */}
                    <Link to="/messenger" className="w-[2.5vmax] h-[2.5vmax] bg-indigo-50 text-indigo-600 rounded-full flex items-center justify-center hover:bg-indigo-100 transition-colors shadow-sm" title="Open Chat">
                        <i className="fa-solid fa-comment-dots text-[1.2vmax]"></i>
                    </Link>
                </div>
            </div>
        </div>
    )
}

export default Humberg;